import type { ReactElement } from 'react';
import cx from 'clsx';
import type { FieldErrorProps } from 'react-aria-components';
import { FieldError } from 'react-aria-components';
import styles from './error.module.css';

export function Error({ className, ...props }: FieldErrorProps): ReactElement {
  return <FieldError className={cx(className, styles.error, 'caption')} {...props} />;
}
